export default function siteLoader() {
    const L = document.getElementById('tz-loader');
    
    if (L) {
        new window.trazan.TextAnimations(L);
    }
    
    window.addEventListener('load', () => {
        const done = () => document.dispatchEvent(new CustomEvent('trazan:siteLoaderDone', { detail: { loader: L } }));

        if (L) {
            setTimeout(() => {
                L.classList.add('is-done');
                L.setAttribute('aria-hidden', 'true');
                done();
            }, 500);
        } else {
            done();
        }
    });
}